import type { ModuleId } from '@tahi/core';
import type { ComponentType } from 'react';

export type TileSize = 'small' | 'wide' | 'tall';

export interface TileDef<C = unknown> {
  type: string; // 'spending.today', 'budget.whats-left', 'quit.today'
  moduleId: ModuleId;
  title: string;
  sizes: TileSize[];
  defaultSize: TileSize;
  defaultOnToday?: boolean; // added to Today when the module is first enabled
  Component: ComponentType<{ size: TileSize; config: C }>;
  Settings?: ComponentType<{ config: C; onChange(c: C): void }>;
}

const defs = new Map<string, TileDef>();

export function registerTile<C>(def: TileDef<C>): void {
  if (!def.sizes.includes(def.defaultSize)) {
    throw new Error(`Tile ${def.type}: defaultSize "${def.defaultSize}" is not in sizes`);
  }
  defs.set(def.type, def as unknown as TileDef);
}

export function getTileDef(type: string): TileDef | undefined {
  return defs.get(type);
}

/** In registration order. */
export function listTileDefs(): TileDef[] {
  return [...defs.values()];
}

export function unregisterTileForTests(type: string): void {
  defs.delete(type);
}
